export const DEFAULT_FILTER = {
  fuelType: [],
  vehicleSize: [],
  stationStatus: ["Operational"],
  hours: [],
  paymentTypes: [],
  source: [],
};

export const DEFAULT_LOCATION = {
  position: { lat: 33.669923828330454, lng: -117.86192591255671 },
  locationName: "4675 MacArthur Court, Newport Beach, CA 92660",

  // position: { lat: 38.8951, lng: -77.0364 },
  // locationName: "Washington, D.C.",

  // position: { lat: 33.6189, lng: -117.9298 },
  // locationName: "Newport Beach",
};
